// Note that the values are intentionally named the same as their corresponding components
export enum SELF_SERVE_SECTION {
  LEASE_UPLOAD = 'LeaseUpload',
  LEASE_UPLOAD_MULTI_FILE = 'LeaseUploadMultiFile',
  ADDITIONAL_DETAILS = 'AdditionalDetails',
  LEASE_UPLOAD_MULTI_FILE_SIGNED = 'LeaseUploadMultiFileSigned',
  LEASE_UPLOAD_ALREADY_SIGNED_MULTI_FILE = 'LeaseUploadAlreadySignedMultiFile',
  LEASE_UPLOAD_ALREADY_SIGNED_MULTI_FILE_COMPLETE = 'LeaseUploadAlreadySignedMultiFileComplete',
}

export const STRING_CONSTANTS = {
  [SELF_SERVE_SECTION.LEASE_UPLOAD_MULTI_FILE]: {
    heading: 'Lease and supporting documents',
    description: (
      <>
        Add your lease and any addenda that you want signed. Use a descriptive name for each document so your tenants
        know what they are signing. Add up to 10 documents.
      </>
    ),
  },
  [SELF_SERVE_SECTION.LEASE_UPLOAD_ALREADY_SIGNED_MULTI_FILE]: {
    heading: 'Lease and supporting documents',
    description: <>This is the lease and any supporting documents you and your tenant signed.</>,
  },
  [SELF_SERVE_SECTION.LEASE_UPLOAD_ALREADY_SIGNED_MULTI_FILE_COMPLETE]: {
    heading: 'Lease and supporting documents',
    description: <>This is the lease and any supporting documents you and your tenant signed.</>,
  },
  [SELF_SERVE_SECTION.LEASE_UPLOAD_MULTI_FILE_SIGNED]: {
    heading: 'Signed lease packet',
    description: <>The signed lease packet includes documents files with everyone’s signatures.</>,
  },
  LANDLORD_CATEGORY_DESCRIPTION_OVERRIDES: {
    selfServePartiesToTheLease: 'The lease will be sent to each person‘s email to be signed',
    selfServeTermsAndPayment: 'We will send you a reminder when the lease is approaching its expiration date',
    selfServeRentAndDeposit: 'These are the amounts you previously selected',
  },
  LANDLORD_CATEGORY_DESCRIPTION_SIGNED_LEASE_OVERRIDES: {
    selfServePartiesToTheLease: 'Make sure the lease is signed by the tenants and landlords',
    selfServeTermsAndPayment: 'We will send you a reminder when the lease is approaching its expiration date',
    selfServeRentAndDeposit: 'These are the amounts you previously selected',
  },
  TENANT_CATEGORY_DESCRIPTION_OVERRIDES: {
    selfServePartiesToTheLease: ' ',
    selfServeTermsAndPayment: ' ',
    selfServeRentAndDeposit: ' ',
  },
  COLANDLORD_CATEGORY_DESCRIPTION_OVERRIDES: {
    selfServePartiesToTheLease: ' ',
    selfServeTermsAndPayment: ' ',
    selfServeRentAndDeposit: ' ',
  },
};
